import type { ZodInfer } from '@mntn-dev/utility-types'
import { EnumBuilder } from '@mntn-dev/utility-types'

export const [
  InvoicePaymentTermValues,
  InvoicePaymentTermValueSchema,
  InvoicePaymentTermValueMap,
] = EnumBuilder('due_on_receipt', 'net_30', 'net_45', 'net_60', 'net_90')

export type InvoicePaymentTermValue = ZodInfer<
  typeof InvoicePaymentTermValueSchema
>
